/**
 * 通用审批业务类型枚举
 * 
 * Code 编码规则（按业务模块分组，预留扩展空间）：
 * - 1-29: 基础企业相关业务（企业管理员邀请等）
 * - 30-59: 渠道相关业务（渠道邀请、渠道码加入等）
 * - 60-89: 机构相关业务（机构邀请代理授权、机构业务员邀请等）
 * - 90-99: 预留（其他业务类型扩展）
 */
export const BusinessTypeEnum = {
  // ========== 基础企业相关业务 (1-29) ==========
  // 超级管理员邀请
  INVITE_ENTERPRISE_SUPER_ADMIN: {
    code: '1',
    label: '超级管理员邀请'
  },
  // 管理员邀请
  INVITE_ENTERPRISE_ADMIN: {
    code: '2',
    label: '管理员邀请'
  },
  
  // ========== 渠道相关业务 (30-59) ==========
  // 用户通过渠道码加入渠道
  CHANNEL_CODE_JOIN_CHANNEL: {
    code: '30',
    label: '通过渠道码加入渠道'
  },
  // 渠道邀请用户加入
  INVITE_JOIN_CHANNEL: {
    code: '31',
    label: '渠道邀请用户加入'
  },
  // 渠道邀请用户授权代理
  CHANNEL_INVITE_AGENCY_AUTH: {
    code: '32',
    label: '渠道邀请用户授权代理'
  },

  // ========== 机构相关业务 (60-89) ==========
  // 机构邀请代理授权
  ORGANIZATION_INVITE_AGENCY_AUTH: {
    code: '60',
    label: '机构邀请代理授权'
  },
  // 机构业务员邀请
  ORGANIZATION_INVITE_SALESMAN: {
    code: '61',
    label: '机构业务员邀请'
  },
  // ========== 会员单位相关业务 (90-99) ==========
  // 会员单位入会投票
  MEMBERSHIP_VOTING: {
    code: '90',
    label: '会员单位入会投票'
  }
}

/** 需要跳转到「我的授权」页面的业务类型 code 集合（超级管理员邀请、管理员邀请、渠道/机构相关授权等） */
export const AUTH_BUSINESS_TYPE_CODES = new Set([
  BusinessTypeEnum.INVITE_ENTERPRISE_SUPER_ADMIN.code,
  BusinessTypeEnum.INVITE_ENTERPRISE_ADMIN.code,
  BusinessTypeEnum.CHANNEL_CODE_JOIN_CHANNEL.code,
  BusinessTypeEnum.INVITE_JOIN_CHANNEL.code,
  BusinessTypeEnum.CHANNEL_INVITE_AGENCY_AUTH.code,
  BusinessTypeEnum.ORGANIZATION_INVITE_AGENCY_AUTH.code,
  BusinessTypeEnum.ORGANIZATION_INVITE_SALESMAN.code
])

/**
 * 是否为「其他授权」类消息（点击后跳转我的授权页）
 * @param {string} businessType - 业务类型 code
 * @returns {boolean}
 */
export function isAuthBusinessType(businessType) {
  return businessType != null && AUTH_BUSINESS_TYPE_CODES.has(String(businessType))
}
